import React from 'react';
import NumberTypePage from './NumberTypePage';

const DIDInternationalNumbers = () => <NumberTypePage type="did" />;

export default DIDInternationalNumbers;
